// 2025(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

export var schoolyear_select = function(selector, next = "") 
{
    next = (next.length > 0) ? next : document.location.href;
    
    document.querySelector(selector).addEventListener("change", (event) => {
        const url = "/session/schoolyear/set/" + event.target.value + "?next=" + encodeURI(next);
        document.location.href = url;
    });
};